export const iconFontAwesomeSpinnersRotateLeft = (
	<i className="fa-solid fa-rotate-left"></i>
);
